import { RotateCcw, Mail } from "lucide-react";
import { COPY } from "@/config/copy";

export default function EmailRestartFooter({ emailStatus, leadEmail, onRestart }) {
  const r = COPY.results;
  return (
    <div className="border-t border-[#E5E5E5] py-16">
      <div className="stage text-center">
        <div className="flex items-center justify-center gap-2 mb-3">
          <Mail size={16} strokeWidth={1.5} />
          <div className="section-label">
            {emailStatus?.sent ? r.email_confirm_sent : r.email_confirm_pending}
          </div>
        </div>
        <div className="font-serif text-lg md:text-xl mb-10 display-tight">
          {emailStatus?.sent ? (
            <>
              {r.email_body_sent} <span className="italic">{leadEmail}</span>.
            </>
          ) : (
            <>{r.email_body_pending}</>
          )}
        </div>
        <button className="btn-ghost" onClick={onRestart} data-testid="restart-btn">
          <RotateCcw size={12} strokeWidth={1.5} />
          {r.restart_label}
        </button>
      </div>
    </div>
  );
}
